module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticClass: "component-wallet-record-list"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Wallet records")]), (_vm.expanded) ? _c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.walletAddCostToggle = !_vm.walletAddCostToggle
      }
    },
    slot: "action"
  }) : _vm._e(), _c('i', {
    staticClass: "fa fa-2x",
    class: {
      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
    },
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    },
    slot: "action"
  }), _c('ActionButton', {
    attrs: {
      "slot": "action",
      "button": false,
      "action": _vm.refreshList
    },
    slot: "action"
  }, [_c('span', {
    staticClass: "fa fa-refresh fa-2x",
    staticStyle: {
      "color": "white"
    }
  })])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "wallet"
  }, [(_vm.value.amounts['RECORDS_VATIN'] != _vm.value.amounts['BALANCE_VATIN']) ? [_c('h3', [_vm._v("Current Balance: " + _vm._s(_vm.$priceWithcurrency(_vm.value.amounts['RECORDS_VATIN'])))]), (_vm.value.amounts['UNINVOICED_RECORDS_VATIN'] !== '0.00') ? _c('span', {
    staticClass: "small"
  }, [_vm._v("(Inc. " + _vm._s(_vm.$priceWithcurrency(_vm.value.amounts['UNINVOICED_RECORDS_VATIN'])) + " of uninvoiced items)")]) : _vm._e()] : _vm._e(), (_vm.value.amounts['UNINVOICED_DEPOSITS_VATIN'] !== '0.00') ? _c('span', {
    staticClass: "small"
  }, [_vm._v("(Inc. " + _vm._s(_vm.$priceWithcurrency(_vm.value.amounts['UNINVOICED_DEPOSITS_VATIN'])) + " of uncredited deposits)")]) : _vm._e(), (_vm.walletAddCostToggle) ? _c('wallet-add-cost', {
    attrs: {
      "wallet": _vm.value
    }
  }) : _vm._e(), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('base-list', {
    ref: "wrList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "resultsPerPage": 5,
      "search": _vm.search,
      "component-type": "multi-wallet"
    }
  })], 1)], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8ab69d74!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/MultiWallet.vue
// module id = 2632
// module chunks = 1